import { State } from "../../../Reducers"
import { hasValue } from "../../../Models/Client/FetchState"
import { Result } from "../../../Models/Utility/Result"
import { createSelector } from "reselect"
import { ProjectRole } from "../../../Models/Client/ProjectRole"
import { selectIsSysAdmin, selectIsSysCrowdManager } from "./auth"

let roleFetchResults: Result<ProjectRole[]>[] = []

/**
 * Returns list of all roles that apply to logged-in user.
 */
export const selectAssumedRoles = createSelector(
    (state: State, appID: string) => state.api.apps.apps.records.get(appID),
    selectIsSysAdmin,
    selectIsSysCrowdManager,
    (appFetch, isSysadmin, isSysCrowdManager) => {
        if (!hasValue(appFetch)) {
            return appFetch
        }

        const roles = ([] as ProjectRole[]).concat(
            isSysadmin ? ["SYSADMIN"] : [],
            isSysCrowdManager ? ["SYSCROWDMANAGER"] : [],
            appFetch.value.role === null ? [] : [appFetch.value.role],
            appFetch.value.workerRole === null
                ? []
                : [appFetch.value.workerRole]
        )

        // To maintain referential equality (which is required to be React friendly),
        // returns object in the list if it already exists
        const matched = roleFetchResults.find(
            r =>
                hasValue(r) &&
                r.value.length === roles.length &&
                roles.every((rr, i) => rr === r.value[i])
        )

        if (matched !== undefined) {
            return matched
        }

        const newResult = Result.ok(roles)

        roleFetchResults.push(newResult)

        return newResult
    }
)
